import React from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarUserMenu, { type SidebarUserMenuItem } from '@shared/components/SidebarUserMenu';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Bottom block of the admin Sidebar. Thin wrapper over the shared
 * `SidebarUserMenu` — supplies the admin auth shape (Spanish-only labels,
 * `is_platform_admin` role line) and the Mis talleres /
 * Cerrar sesión menu items.
 */
const SidebarUserPanel: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim();

  const items: SidebarUserMenuItem[] = [
    { icon: 'account_circle', label: 'Mis talleres', onClick: () => navigate('/mi-cuenta') },
    { icon: 'logout', label: 'Cerrar sesión', onClick: () => void logout(), danger: true },
  ];

  return (
    <SidebarUserMenu
      avatarUrl={user?.avatar_url}
      avatarName={fullName || user?.username || user?.email || ''}
      displayName={user?.first_name || user?.username || ''}
      roleLabel={user?.is_platform_admin ? 'Admin' : 'Usuario'}
      roleTintClass={user?.is_platform_admin ? 'text-primary' : 'text-slate-500'}
      items={items}
      triggerAriaLabel="Menú de usuario"
      menuAriaLabel="Menú de usuario"
    />
  );
};

export default SidebarUserPanel;
